import React from "react";
import "../css/PricingPlans.css"


const PricingPlans = () => {
    const plans = [
        { title: "Basic", features: ["Standard website", "Pre-designed templates (limited customization)", "Mobile-responsive design", "Contact form & social media integration", "Hosting & domain setup assistance", "Free SSL", "24/7 support"], colorClass: "green" },
        { title: "Standard", features: ["Custom-designed website", "Advanced UI/UX customization", "Blog & CMS integration", "Basic web application(e.g.user logins, dashboards)", "E-commerce setup", "Free SSL", "Including Basic Plan Features", "24/7 support & maintenance"], colorClass: "orange" },
        { title: "Premium", features: ["Mobile application (android & IOS)", "Website and web application", "Advanced UI/UX design tailored to brand identity", "ERP solutions", "Free SSL", "Including Standard Plan Features", "24/7 premium support & maintenance"], colorClass: "purple" },
    ];

    return (
        <div id="pricing" className="demo pricing">
            <div className="container">
                <div className="col-md-10 col-md-offset-1 section-title">
                    <h2>Choose Plan</h2>
                </div>
                <div className="row">
                    {plans.map((plan, index) => (
                        <div className="col-md-3 col-sm-6" key={index}>
                            <div className={`pricingTable ${plan.colorClass}`}>
                                <div className="pricingTable-header">
                                    {/* <span className="price-value">{plan.price}<span className="currency">$</span></span> */}
                                    <h3 className="title" style={{ fontSize: "35px", color: "white" }}>{plan.title}</h3>
                                </div>
                                <ul className="pricing-content">
                                    {plan.features.map((feature, idx) => (
                                        <li key={idx}>{feature}</li>
                                    ))}
                                </ul>
                                <a href="#contact" className="pricingTable-signup">Contact</a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PricingPlans;